import { render, staticRenderFns } from "./policy-manage.vue?vue&type=template&id=62577780&"
import script from "./policy-manage.vue?vue&type=script&lang=js&"
export * from "./policy-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports